import styled from 'styled-components';
import {Typography} from "@mui/material";

export const DigitizationDetailsSidebarWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    overflow-y: auto;
`;

export const StyledVerificationInfo = styled(Typography)`
    display: flex;
    align-items: center;
    gap: 6px;
`;